/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface DeleteFleetsFleetIdSquadsSquadIdNotFound
 */
export interface DeleteFleetsFleetIdSquadsSquadIdNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof DeleteFleetsFleetIdSquadsSquadIdNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the DeleteFleetsFleetIdSquadsSquadIdNotFound interface.
 */
export function instanceOfDeleteFleetsFleetIdSquadsSquadIdNotFound(value: object): value is DeleteFleetsFleetIdSquadsSquadIdNotFound {
    return true;
}

export function DeleteFleetsFleetIdSquadsSquadIdNotFoundFromJSON(json: any): DeleteFleetsFleetIdSquadsSquadIdNotFound {
    return DeleteFleetsFleetIdSquadsSquadIdNotFoundFromJSONTyped(json, false);
}

export function DeleteFleetsFleetIdSquadsSquadIdNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteFleetsFleetIdSquadsSquadIdNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function DeleteFleetsFleetIdSquadsSquadIdNotFoundToJSON(json: any): DeleteFleetsFleetIdSquadsSquadIdNotFound {
    return DeleteFleetsFleetIdSquadsSquadIdNotFoundToJSONTyped(json, false);
}

export function DeleteFleetsFleetIdSquadsSquadIdNotFoundToJSONTyped(value?: DeleteFleetsFleetIdSquadsSquadIdNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

